import { Affix, Button, Card } from "antd";
import { COMMERCIAL_PACKING_REQUIREMENTS_EDIT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { alertPop } from "apiServices/common/helper";
import Header from "components/Common/Header";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import CommercialPackingRequirementForm from "../CommercialPackingRequirementForm";

export default function CommercialPackingRequirementView() {
  const navigate = useNavigate();
  const id = useParams().id;

  const [commercialPackingRequirement, setCommercialPackingRequirement] =
    useState();
  useEffect(() => {
    const getCommercialPackingRequirement = async () => {
      let response = await getData(
        `${COMMERCIAL_PACKING_REQUIREMENTS_EDIT}/${id}`,
        false,
      );
      if (response && response?.status === 200) {
        let masterData = response?.data;
        setCommercialPackingRequirement(masterData?.data);
      } else {
        alertPop(
          "error",
          response?.messages ? response?.messages : "Something Went Wrong!",
        );
      }
    };
    getCommercialPackingRequirement();
  }, [id]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title="View Commercial Packing Requirement"
            subTitle=""
            addLink="/"
            addText="Submit"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() => navigate(-1)}
                >
                  Discard
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <CommercialPackingRequirementForm
        mode="view"
        data={commercialPackingRequirement}
        setData={setCommercialPackingRequirement}
      />
    </>
  );
}
